// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.nuxt-link-active[data-v-d31ec5f2],a.nuxt-link-exact-active[data-v-d31ec5f2]{background-color:#073370;border-radius:6px}a.nuxt-link-exact-active[data-v-d31ec5f2]{height:40px}.transition-height[data-v-d31ec5f2]{transition:height .25s;transition-timing-function:linear}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
